import { ApplyEngagementBlueprintButton } from "PFApp/activities/engagement_blueprint/components/apply_engagement_blueprint_button";
import { useActivityPermissions } from "PFApp/activities/hooks";
import { ManageRolesButton } from "PFApp/activities/manage_roles/components/manage_roles_button";
import { useActivityShowContext } from "PFApp/activities/show/context/activity_show_context";
import { useActivityPageRoles } from "PFApp/activities/show/hooks/use_activity_page_roles";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { AddRoleButton } from "PFApp/activities/show/parts/add_role_button";
import { useActivityTabsStoreActions } from "PFApp/activities/show/store/activity_tabs";
import { TemplateKey } from "PFApp/constants/templates";
import { ActionIcon } from "PFComponents/action_icon";
import { Inline } from "PFComponents/containers";
import { Tile } from "PFComponents/tile";
import { Typography } from "PFComponents/typography";
import { useIsCurrentUserPermittedTo } from "PFCore/helpers/use_is_permitted_to";
import { PermissionRule } from "PFTypes";
import { useTranslation } from "react-i18next";

export const ActivityRolesSummary = () => {
  const { t } = useTranslation("activities", { keyPrefix: "show.details.roles" });
  const { roles } = useActivityPageRoles();

  const { isEngagement, roleKey } = useActivityShowContext();
  const activity = useCurrentActivity();
  const { canCreateRoles } = useActivityPermissions(activity);
  const { changeTab } = useActivityTabsStoreActions();
  const canBulkManageRoles = useIsCurrentUserPermittedTo(PermissionRule.BulkManageRoles);

  const canAddRole = activity.state !== "complete" && isEngagement && canCreateRoles;

  const rolesTextContent = roles.meta.total ? t("title", { count: roles.meta.total }) : t("noRoles");

  const handleOpenRoles = () => {
    changeTab("roles");
  };

  if (!isEngagement) {
    return null;
  }

  return (
    <Tile variant="light" paddingVariant="lg" qaId="ActivityDetailsRoles">
      <Inline alignItems="center" spread>
        <Inline alignItems="center" gap="spacingSm">
          <Typography variant="h5">{rolesTextContent}</Typography>
          <ActionIcon name="open" onClick={handleOpenRoles} />
        </Inline>
        {canAddRole && (
          <Inline>
            {roleKey === TemplateKey.Role && canBulkManageRoles && (
              <ManageRolesButton engagementId={activity.id} />
            )}
            {roleKey === TemplateKey.Role && <ApplyEngagementBlueprintButton activityId={activity.id} />}
            <AddRoleButton activityId={activity.id} roleKey={roleKey} />
          </Inline>
        )}
      </Inline>
    </Tile>
  );
};
